export default {
  actualData: "البيانات الفعلية",
  actualDataReport: "تقرير البيانات الفعلية",
  actualDelivery: "التسليم الفعلي",
  actualDeliveryTime: "وقت التسليم الفعلي",
  actualPickup: "الاستلام الفعلي",
  actualPlaceholder: "البحث عن طريق رقم الطلب، العميل",
  cancellationAndReturn: "الإلغاء والإرجاع",
  cancellationAndReturnReport: "تقرير الإلغاء والإرجاع",
  cancellationOrReturnDate: "الإلغاء/تاريخ الإرجاع",
  customer: "العميل",
  deliveredDate: "تاريخ التسليم",
  deliveryId: "معرف التسليم",
  deliveryLocation: "موقع التسليم",
  deliveryPerformance: "أداء التسليم",
  deliveryPerformancePlaceholder:
    "البحث عن طريق رقم الطلب، معرف التسليم، الحالة",
  deliveryPerformanceReport: "تقرير أداء التسليم",
  detailed: "تفصيلي",
  detailedOrders: "الطلبات التفصيلية",
  detailedOredersReport: "تقرير الطلبات التفصيلي",
  detailedPlaceholder: "البحث عن طريق رقم الطلب، اسم السائق، العميل",
  downloadError: "فشل في تنزيل التقرير",
  downloadSuccess: "تم تنزيل التقرير بنجاح",
  driverId: "رقم السائق",
  driverName: "اسم السائق",
  earlyOrLateMinutes: "الدقائق المبكرة/المتأخرة",
  exportAs: "تصدير بصيغة",
  invoiceAndPayment: "الفاتورة والدفع",
  invoiceAndPaymentPlaceholder: "البحث عن طريق رقم الطلب",
  invoiceAndPaymentReport: "تقرير الفاتورة والدفع",
  itemizedCosts: "التكاليف المفصلة",
  listOfReports: "قائمة التقارير",
  onlyFourDecimalPlacesAllowed: "يسمح بأربعة أرقام عشرية فقط",
  paymentStatus: "حالة الدفع",
  pending: "في انتظار الدفع",
  printReport: "طباعة التقرير",
  reason: "السبب",
  reportsAndAnalytics: "التقارير والتحليلات",
  schedualedDate: "التاريخ المجدول",
  schedualedDeliveryTime: "وقت التسليم المجدول",
  scheduledPickup: "الاستلام المجدول",
  sheduledDelivery: "التسليم المجدول",
  summary: "ملخص",
  time: "الوقت",
  timePerformance: "أداء الوقت",
  timePerformancePlaceholder: "البحث عن طريق رقم الطلب، رقم السائق",
  timePerformanceReport: "تقرير أداء الوقت",
  totalAmountBilled: "المبلغ الإجمالي المفوتر",
};
